/** Returns a copy of the object with all null-valued keys omitted. */
export function omitNullValues<T extends object>(
  obj: T
): { [K in keyof T]: Exclude<T[K], null> } {
  return Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== null)
  ) as { [K in keyof T]: Exclude<T[K], null> };
}
